export default ({
  STAGE: process.env.NODE_ENV || 'development',
  // API: 'https://w9ahxniyu3.execute-api.ap-northeast-1.amazonaws.com/prod/oakmember',
  // API: 'http://localhost:8080',
  API: process.env.NODE_ENV === 'production' ? 'https://oakhouse-competition.japansoftwarecorp.com' : 'http://localhost',
  GOOGLE_ANALYTICS: 'UA-134099424-3',
  // NOTE: First one in the list will be the system defalt.
  AVAILABLE_LANGUAGES: ['en', 'ja'],
});
